import { PickKeyOfObject, PickKeyOfString, PickObjectRecursive } from "@/common/declare";
import { observable } from "vue/types/umd";

const properNoun = {

}

const dlc = {
    /**全局空间,此对象不可删除 */
    global: {
        input_search: '搜索',
        input_export: '导出',
        input_filter: '筛选',
        input_sync: '刷新',
        input_add: '添加',
        input_copy: '复制',
        input_edit: '编辑',
        input_enable: '启用',
        input_disable: '禁用',
        input_confirm: '确定',
        input_cancel: '取消',
        label_nav_create: '创建',
        label_nav_edit: '编辑',
        label_warn: '提示',
        label_confirm_delete: '数据删除后无法恢复，是否继续？',
        label_confirm_cancel: '执行此操作将失去当前的所有输入，是否继续？',
        msg_copy_success: '复制成功',
        label_yes: '是',
        label_no: '否',
        lang_eng: '英文',
        lang_cn: '中文',
        enum_currency_THB: '฿',
        enum_currency_USD: '$',
        enum_currency_CNY: '¥',
        
        //#region 表单验证组件的默认值

        /**必填提示 */
        require: '请输入{0}',
        /**手机号格式默认提示 */
        require_phoneNumber: '请填写正确的手机号格式',

        //#endregion
    },

    /**路由页面 */
    router: {
        addStock: '添加库存',
        editStock: '编辑库存',
        stockList: '库存',
        stockDetail: '库存详情',
        productDetail: '商品信息',
        brand: '品牌管理'
    },

    /**主页 */
    home: {
        welcome_1: '欢迎使用Fanslink中控系统',
        welcome_2: ' ',
        input_account_hint: '请输入账号',
        input_password_hint: '请输入密码',
        input_login: '登  录',
        input_remember: '记住密码',
        link_forget: '忘记密码？',
        link_regist_1: '没有账号？去',
        link_regist_2: '注册',
        require_account: '账号不能为空',
        require_password: '密码不能为空',
    },

    // 广告管理
    advert: {
        form: {
            ph_searchTip: '请输入广告名称',
            ph_status: '状态',
            enum_active: '启用',
            enum_disable: '禁用',
            input_search: '搜索',
            input_add: '添加广告',
            th_num: '#',
            th_pic: '广告图片',
            th_name: '广告名称',
            th_jumpType: '跳转类型',
            th_sort: '排序',
            th_createTime: '创建时间',
            th_status: '状态',
            th_opr: '操作',
            input_edit: '编辑',
            input_delete: '删除',
            ph_tip:'*仅显示状态为正常中排序最高的一张广告图'
        },
    },
    productnew: {
        form: {
            th_pic:'产品图片',
            th_name:'产品名称',
            th_barcode:'Barcode',
            th_skuCode:'SKU',
            th_serviceMonth:'保修期(月)',
            th_operatingEN:'操作手册(EN)',
            th_operatingTHAI:'操作手册(THAI)',
            th_videoUrl:'Video',
            th_remark:'备注',
            th_createTime:'创建时间',
            th_oper:'操作',
            input_delete:'删除',
            ph_searchTip:'请输入产品名称/barcode/sku进行搜索',
            

        },
        add:{
            th_img:'产品图片',
            th_name:'产品名称',
            th_barcode:'Barcode',
            th_sku:'SKU',
            th_serviceMonth:'保修期',
            th_oper:'操作',
            th_warranty:'保修期',
            oper_add:'添加',
            oper_added:'已添加',
            label_code:'Barcode',
            label_total:'Total',
            label_nameEN:'产品名称EN',
            label_nameTH:'产品名称TH',
            label_barCode:'barcode',
            label_skuCode:'SKU code',
            label_serviceMonth:'保质期(月)',
            label_video:'Video',
            label_img:'产品图片',
            label_operEN:'操作手册(EN)',
            label_operTH:'操作手册(TH)',
            require_nameEN:'请填写名称',
            require_nameTH:'请填写名称',
            require_barCode:'请填写barCode',
            require_sku:'请填写skuCode',
            require_fileList:'请上传图片',
            
        }
        
    },
    admin:{
        form:{
            th_username:'用户名称',
            th_roleName:'角色',
            th_createTime:'创建时间',
            th_status:'状态',
            th_opr:'操作',
            enum_active:'启用',
            enum_disable:'禁用',
            input_edit:'编辑',
            ph_searchTip:'用户名',
            input_search:'搜索',
            input_add:'添加',
            label_edit:'编辑',
            // roleList
            th_name: '角色',
            th_remark: '备注',
        },
    },
    // 用户管理
    user: {
        enum_female: 'Female',
        enum_male: 'Male',
        enum_secret: 'Secret',
        form: {
            ph_searchTip: '请输入用户名称/Email/手机号进行搜索',
            ph_status: '用户状态',
            enum_active: '启用',
            enum_disable: '禁用',
            input_search: '搜索',
            input_export: '导出',
            th_username: '用户名称',
            th_name: '用户昵称',
            th_gender: '性别',
            th_birthday: '出生日期',
            th_mobile: '手机号',
            th_email: '邮箱',
            th_address: '地址',
            th_productCount: '注册产品数',
            th_createTime: '注册时间',
            th_loginAt: '上次登录时间',
            th_status: '状态',
            th_opr: '操作',
            input_edit: '编辑',
            input_detail: '查看',
            input_active: '启用',
            input_disable: '禁用',
            input_delete: '删除',
            label_detail: '查看详情',
            label_edit: '编辑',
        },
        detail: {
            lable_username: 'User Name',
            lable_password: 'Password',
            lable_firstname: 'First Name',
            lable_lastname: 'Last Name',
            lable_nickname: 'Nick Name(optional)',
            lable_gender: 'Gender',
            lable_birth: 'Date of birth',
            lable_mobile: 'Mobile Number',
            lable_email: 'Email',
            lable_address: 'Address',
            input_editPaddword: '修改密码',
            lable_rePasswd: 'Confirm Password',
            lable_passwd: 'New Password',
            require_password: '密码不匹配',
        },
        productForm: {
            ph_productSearchTip: '请输入产品ID/名称/Barcode/SKU进行搜索',
            ph_picoSearchTip: '请输入名称/Barcode/SKU进行搜索',
            ph_userSearchTip: '请输入用户名称/Email/手机号进行搜索',
            ph_picoUserSearchTip: '请输入Email/手机号进行搜索',
            ph_place: '购买渠道',
            input_edit: '编辑',
            input_view: '详情',
            input_delete: '删除',
            th_id: 'ID',
            th_img: '产品图片',
            th_productName: '产品名称',
            th_code: 'Barcode',
            th_barCode: 'Barcode',
            th_serialNumber: 'Serial Number',
            th_skuCode: 'SKU',
            th_userInfo: '用户信息',
            th_purchaseDate: '购买日期',
            th_expireDate: '保修期到期时间',
            th_createTime: '产品注册时间',
            th_purchasePlace: '购买渠道',
            th_purchasedFrom: '购买渠道',
            th_opr: '操作',
        },
        productDetail: {
            label_nameEn: '产品名称(EN)',
            label_nameTh: '产品名称(TH)',
            label_barcode: 'Barcode',
            label_sku: 'SKU code',
            label_serviceMonth: '保修期(月)',
            label_remark:'备注',
            label_serialNumber: 'Serial Number(optional)',
            label_purchasePlace: '购买渠道',
            label_shopName: '店铺名称',
            label_purchaseDate: '购买日期',
            label_purchaseRecord: '购买凭证',
            label_createTime: '产品注册时间',
            label_expireDate: '过期时间',
            label_contactName: '联系人姓名',
            label_contactMobile: '联系人电话',
            label_contactEmail: '联系人邮箱',
            label_username: '用户姓名',
            label_nickname: '用户昵称',
            label_mobile: '手机号',
            label_email: '邮箱',
            label_userCreateTime: '注册时间',
            label_productCount: '注册产品数',
            input_confirm: '确认',
            input_cancel: '取消',
            header_goback: '返回',
            header_detail: '详情'
        },
    },

    activity: {
        form: {
            ph_searchTip: '请输入活动名称',
            ph_status: '状态',
            input_edit: '编辑',
            input_detail: '查看',
            input_delete: '删除',
            th_title: '活动名称',
            th_serviceMonth: '保修期增减数量(月)',
            th_startDate: '产品注册开始时间',
            th_endDate: '产品注册结束时间',
            th_status: '活动状态',
            th_productCount: '关联产品数量',
            th_opr: '操作',
            label_detail: '查看',
        },
        detail: {
            label_registrationPeriod: '产品注册时间段',
            label_serviceMonth: '保修期增减数量(月)',
            label_productCount: '关联产品数量',
            label_title: '活动名称',
            th_img: '商品图片',
            th_name: '商品名称',
            th_code: '商品代码',
            input_add: '添加商品',
            input_delete: '删除',
            th_status: '状态',
            label_add: '可添加',
            label_added: '已添加',
            ph_searchTip:'请输入产品名称/barcode/sku进行搜索',
        },
    },

    /**商品信息(deprecated) */
    product: {
        product: '商品信息',
        tab_all: '所有产品',
        tab_shelf: '已上架',
        tab_review: '审核中',
        tab_not_shelf: '未上架',
        tab_draft: '草稿',
        tab_deleted: '已删除',
        filter_stock: '可购库存',
        filter_sold: '销量',
        filter_cost: '成本',
        input_search: '搜索',
        input_filter: '筛选',
        input_sync: '同步库存',
        input_add: '添加商品',
        th_barcode: 'Barcode',
        th_name: '产品名称',
        th_update: '最近更新时间',
        th_stock: '总库存',
        th_cached: '缓冲库存',
        th_used: '占用库存',
        th_selling: '可购买',
        th_sold: '销售量',
        th_shelf: '上架店铺数',
        th_state: '状态',
        th_oper: '操作',
        oper_edit: '编辑',
        oper_more: '更多操作',
    },

    /**组件分离出的逻辑 */

    //图片/视频/pdf输入组件,由于功能有重叠,放在一起
    mediaInputs: {
        up_error: '上传发生错误',
        size_error: '请勿上传空文件',
        img: {
            type_error: '请传入图片!'
        },
        pdf: {
            type_error: '请传入PDF文件!'
        },
        video: {
            type_error: '请传入视频!'
        }
    },

    //商品输入(严格来说不算公用组件)
    prdInput: {
        step_1: '01.产品详细信息',
        step_2: '02.尺寸',
        step_3: '03.仓储管理属性',
        step_4: '04.价格信息',
        step_5: '05.图片信息',
        step_6: '06.商品详情',
        step_7: '07.售后信息',
        step_8: '08.认证进口信息',
        require_brand: '请填写品牌',
        require_barcode: '请填写Barcode',
        require_name: '请填写产品名称',
        require_sku: '请填写SKU',
        require_month: '请填写月份',
        require_way: '请填写售后方式',
        require_partnerId: '请填写供应商',
        require_weight: '请填写重量',
        require_height: '请填写高度',
        require_width: '请填写宽度',
        require_length: '请填写长度',
        label_source: '商品来源',
        label_self: '平台自营',
        label_practicality: '实物寄售',
        label_virtual: '虚拟寄售',
        label_supplier: '供应商',
        label_barcode: 'Barcode',
        label_sku: 'SKU',
        label_name: '产品名称',
        label_brand: '品牌',
        label_weight: '重量',
        label_height: '高度',
        label_width: '宽度',
        label_length: '长度',
        label_clip: '是否拆单',
        label_single_cost: '单件运费',
        label_garantee: '是否购买保险',
        label_transFee: '是否免运费',
        label_g: '克',
        label_mm: '毫米',
        label_thb: '泰铢',
        label_month: '月',
        label_yes: '是',
        label_no: '否',
        label_small: '小件',
        label_big: '大件',
        label_persent: '%',
        label_stock_control: 'SN或IMEI管控',
        label_none: '无',
        label_status: '禁用/启用',
        label_stock: '可用库存',
        label_cost: '成本价',
        label_b2b: 'B2B',
        label_2b2c: 'S2B2C',
        label_vip: 'vip价格',
        label_online_app: 'Online And APP',
        label_kd_credit: 'KD Price(Credit)',
        label_kd_cash: 'Dealer Price',
        label_drop_ship: 'Drop Ship Price',
        label_credit: 'KD Price',
        label_cash: 'Dealer Price',
        label_offline_srp: 'Offline SRP',
        label_dayly: 'Daily Price',
        label_promotion: 'Promotion Price',
        label_flash_sale: 'Flash Sales Price',
        label_online_srp: 'Online SRP',
        label_mega_campain: 'Mega Campaign',
        label_is_vip: '是否VIP优惠商品',
        label_is_fans: '是否FANS优惠商品',
        label_fans: 'FANS价格',
        label_cover: '封面',
        label_tag: '产品标签图片',
        label_slider: '轮播图',
        label_vido: 'Vido',
        label_size_hint: '尺寸在 330x330 和 5000x5000px之间',
        label_as_limit: '售后期限',
        label_as_way: '售后方式(多选)',
        label_as_home: '上门服务(只限曼谷)',
        label_repair: '维修',
        label_change: '换货',
        label_refund: '退款',
        label_have: '有',
        label_pdf_upload: '上传PDF',
        label_hs_code: 'HS Code',
        label_import_duty: 'Normal Import duty',
        label_from_e: 'Use from E',
        input_create: '确认创建',
        input_create_next: '创建并新建下一个',
        input_cancel: '取消',
        msg_price_change: '{1}, {0} 已重新计算',
        msg_sub_bysize: '由于尺寸改变',
        msg_sub_bycash: '由于Dealer Price改变',
        msg_sub_bycredit: '由于KD Price(Credit)改变',
        label_cancel: '执行此操作将失去当前的所有输入，是否继续？',
        dlg_priceAlert: '所有价格都需要填写一个大于零的数值，请检查您的输入。',
        dlg_priceConfirm: '所有价格都需要填写一个大于零的数值，您目前没有这样做，这可能导致审核不通过，是否继续？',
        label_warn: '提示',
        input_confirm: '确定',
    },
    //分页
    pagination: {
        label_total: '共 {0} 个 每页数量',
    },
    //tab
    tabs: {
        tab_all: '所有商品',
        tab_assoc: '已关联商品',
        tab_nonAssoc: '未关联商品',
        tab_inadequate: '库存不足',
        tab_exhausted: '缺货',
        tab_deleted: '删除的商品',
    },

}

type LangPack = typeof dlc;

export type I18nBase = Exclude<PickKeyOfObject<LangPack>, 'global' | '_f'>
export type I18nExtend<T extends keyof LangPack> = PickKeyOfObject<LangPack[T]>

export type LangNps = PickObjectRecursive<typeof dlc>

export default { dlc };